export const fmtTime = (iso) =>
    iso
        ? new Date(iso).toLocaleString(undefined, {
              year: "numeric", month: "short", day: "numeric",
              hour: "numeric", minute: "2-digit", timeZoneName: "short",
          })
        : "";

export const STATUS_LABEL = {
    ai_answered: "Answered by assistant",
    open: "Waiting for Director K",
    answered: "Answered by Director K",
};
